export const initialState = {
   currStageIdx: 0,
   discount: 0,
   discounts: [],
   soldOut: false,
   deadline: '',
   tickets: [],
   ticketsArr: [],
   addOns: {},
   ticketFields: {},
   cart: [],
   fields: [],
   promoCode: '',
   price: {
      fees: 0,
      total: 0,
   },
   calculateTotal: false,
   paymentInfo: {},
   processOrder: false,
   orderResponse: {},
   freezeLoader: false,
   invalidInputMsg: [],
   modals: {
      registerForm: false,
   },
}
